/* eslint-disable camelcase */
/* eslint-disable react/no-array-index-key */
/* eslint-disable react/no-unused-state */
import React, { Component } from 'react';
import { PERMISSIONS } from '../../constants';
import { formatProbability } from '../../utils/common';

class AssignedPlayersTable extends Component {
  constructor(props) {
    super(props);
    this.state = {
      openedInputField: null,

      goalProbabilities: [],
    };
  }

  componentDidUpdate() {
    if (this.state.goalProbabilities.length === 0) {
      const goalProbabilities = this.props.selectedPlayers
        ?.map((player) => player?.goal_probability);
      if (goalProbabilities?.every((probability) => probability !== null)) {
        this.setState({
          goalProbabilities,
        });
      }
    }
  }

  toggleInput = (id) => {
    if (this.props.checkPermission(PERMISSIONS.GOALSCORER_SQUAD_UPDATE)) {
      this.setState({
        openedInputField: this.state.openedInputField === id ? null : id,
      });
    }
  };

  updatePlayerList = (playerIdToAdd, playerIdToRemove, squadPosition) => {
    this.props.updatePlayerOnSquadList({
      playerIdToAdd,
      playerIdToRemove,
      squadPosition,
    });

    this.setState({
      openedInputField: null,
    });
  };

  render() {
    const playersOnBench = this.props.playersList?.filter((player) => player?.squad_position
      === 0 || player?.squad_position === null);

    return (
      <>
        {this.props.selectedPlayers?.map((player, idx) => (

          <div className="team-section__row" key={`position-${player?.id}-${idx}`}>
            <div className="team-section__num">{idx + 1}</div>
            <div className="team-section__input-wrap">
              <div
                className={`team-section__input ${this.state.openedInputField === idx && !this.props.editDisabled ? 'open' : ''}`}
                onClick={this.toggleInput.bind(this, idx)}
              >
                <span className="txt">
                  {player?.name ? `${player?.name} ${player?.reference_name ? `(${player?.reference_name})` : ''}` : '-'}
                </span>
              </div>

              <div className="team-section__dropdown">
                <div className="team-section__list">

                  {playersOnBench?.map((playerr) => (
                    <div
                      className="team-section__list-item"
                      key={playerr?.id}
                      onClick={
                        this.updatePlayerList.bind(this, playerr?.id, player?.id, idx + 1)
                      }
                    >
                      {`${playerr?.name} ${playerr?.reference_name ? `(${playerr?.reference_name})` : ''}`}
                    </div>
                  ))}

                </div>
              </div>
            </div>

            <div className="team-section__percentage">
              {`${parseFloat((formatProbability(
                this.props.selectedTeamSquadCompleted
                  ? this.state.goalProbabilities[idx]
                  : this.props.defaultProbabilities?.[idx],
              ) || 0).toFixed(2))}%`}
            </div>
          </div>
        ))}
        <span/>
      </>
    );
  }
}

export default AssignedPlayersTable;
